import { useTranslation } from 'react-i18next';
import { Box, Card, Icon, Typography, DataTable, useMediaQuery } from 'bonfire-kindling';

import DashboardDataTablePagination from './DashboardDataTablePagination';

const DashboardDataTable = ({ count, title, description, DataTableProps }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  return (
    <>
      <Card>
        <Card.Header
          title={
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Icon
                iconName="file-contract"
                style={{ fontSize: isMobile ? '1rem' : '1.25rem', marginRight: '0.8rem' }}
              />
              <Typography
                variant={isMobile ? 'h4' : 'h1'}
                component="h1"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                }}
              >
                {title}
                <Typography
                  variant={isMobile ? 'h4' : 'h1'}
                  component="span"
                  sx={{
                    display: 'inline-block',
                    fontWeight: 'normal',
                    ml: 2,
                    color: theme => theme.palette.brand.grey.grey,
                  }}
                >
                  ({count})
                </Typography>
              </Typography>
            </Box>
          }
        />
        <Card.Content sx={{ '&:last-child': { p: 4 } }}>
          {description && (
            <Typography variant="body2" component="p" sx={{ mb: 2 }}>
              {description}
            </Typography>
          )}
          <DataTable
            ariaLabels={{
              search: t('dashboard.data_table.search'),
              download: t('dashboard.data_table.download'),
            }}
            searchPlaceholder={t('dashboard.data_table.searchPlaceholder')}
            emptyText={t('dashboard.data_table.empty')}
            {...DataTableProps}
          />
        </Card.Content>
      </Card>
    </>
  );
};

DashboardDataTable.Pagination = DashboardDataTablePagination;

export default DashboardDataTable;
